export default __webpack_public_path__ + "static/media/EQM.ab1aca05.png";